import React from 'react';

const Instagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#0F161E"
      fillRule="evenodd"
      d="M3.678 3.678C4.824 2.533 6.252 2.134 7.877 2.06 8.943 2.012 9.284 2 12 2s3.057.012 4.123.06c1.625.074 3.053.473 4.199 1.618 1.146 1.146 1.544 2.574 1.618 4.199.048 1.066.06 1.407.06 4.123s-.012 3.057-.06 4.123c-.074 1.625-.473 3.053-1.618 4.199-1.146 1.146-2.574 1.544-4.199 1.618-1.066.048-1.407.06-4.123.06s-3.057-.012-4.123-.06c-1.625-.074-3.053-.473-4.199-1.618-1.145-1.146-1.544-2.574-1.618-4.199C2.012 15.057 2 14.716 2 12s.012-3.057.06-4.123c.074-1.625.473-3.053 1.618-4.199zm13.56 4.036a.952.952 0 100-1.904.952.952 0 000 1.904zM6.762 12a5.238 5.238 0 1110.476 0 5.238 5.238 0 01-10.476 0zm1.905 0a3.333 3.333 0 106.667 0 3.333 3.333 0 00-6.667 0z"
      clipRule="evenodd"
     />
  </svg>
);

export default Instagram;
